export default "__VITE_ASSET__cc93f866__"